import { ADDRESS_DESER, Address } from "./address"
import { RestResource } from "./common"
import { TAX_NUMBER_TYPES, USA_CITIZENSHIP_TYPES } from "./customer"
import { SchemaDeSerBuilder, type SchemaDeSer } from "./deser"
import {
  NATIONAL_IDENTIFICATION_DESER,
  NationalIdentification,
} from "./national-identification"
import type { DateISOString } from "./util/date-iso-string"

// Shape matches the `additional-trustees` array on POST /entities exactly.
// The primary account holder is NOT a Trustee here — the backend auto-creates
// it as an owner-of-record entity officer.
export class Trustee extends RestResource {
  firstName = ""
  middleName = ""
  lastName = ""
  birthDate: DateISOString | null = null
  email = ""
  taxNumber = ""
  taxNumberType: TAX_NUMBER_TYPES = TAX_NUMBER_TYPES.SSN
  usaCitizenshipType: USA_CITIZENSHIP_TYPES = USA_CITIZENSHIP_TYPES.CITIZEN
  address: Address = new Address()
  nationalIdentification?: NationalIdentification
}

export const TRUSTEE_DESER: SchemaDeSer<Trustee> = new SchemaDeSerBuilder(
  Trustee
)
  .ofString("firstName")
  .ofString("middleName")
  .ofString("lastName")
  .ofString("birthDate")
  .ofString("email")
  .ofString("taxNumber")
  .ofString("taxNumberType")
  .ofString("usaCitizenshipType")
  .ofNested("address", ADDRESS_DESER, Address)
  .ofNested(
    "nationalIdentification",
    NATIONAL_IDENTIFICATION_DESER,
    NationalIdentification
  )
  .ofString("id")
  .toDeSer()
